<p-overlayPanel
    #op
    [style]="{ 'min-width': '200px', padding: '-20px', margin: '-20px' }"
>
    <ng-template pTemplate>
        <div class="conn-grid" style="margin-top: 1px">
            <div></div>
            <button
                pButton
                pRipple
                type="button"
                label="Edit"
                class="p-button-text"
                [style]="{ width: '100%' }"
                icon="pi pi-pencil"
                iconPos="right"
                (click)="editButtonClicked()"
            ></button>
            <button
            pButton
            pRipple
            type="button"
            label="Change Status"
            class="p-button-danger p-button-text"
            [style]="{ width: '100%' }"
            icon=""
            iconPos="right"
            (click)="optionStatusChangeClicked()"
        ></button>
            <button
                pButton
                pRipple
                type="button"
                label="Delete"
                [style]="{ width: '100%' }"
                class="p-button-danger p-button-text"
                icon="pi pi-trash"
                iconPos="right"
                (click)="optionDeleteClicked()"
            ></button>
        </div>
    </ng-template>
</p-overlayPanel>
<div class="conn-card">
    <app-report-top-filter-bar
        [paraReportName]="'discounts'"
        (filterCallbackFunc)="callbackFuncFromFilter($event)"
        (filterCallbackFuncUpdateFilter)="filterButtonPressed()"
        (exportExcelFn)="exportExcel()"
        (exportPdfFn)="exportPdf()"
        (deleteItemFn)="optionDeleteClicked()"
    ></app-report-top-filter-bar>

    <!-- View Toggle Buttons -->
    <div class="flex gap-2 mb-3">
        <button pButton pRipple type="button" icon="pi pi-list" 
            [class.p-button-outlined]="viewMode !== 'table'"
            [class.p-button-primary]="viewMode === 'table'"
            (click)="viewMode = 'table'" title="Table View"></button>
        <button pButton pRipple type="button" icon="pi pi-th-large" 
            [class.p-button-outlined]="viewMode !== 'card'"
            [class.p-button-primary]="viewMode === 'card'"
            (click)="viewMode = 'card'" title="Card View"></button>
    </div>

    <br />

    <!-- Table View -->
    <p-table
        *ngIf="dataList?.length > 0 && viewMode === 'table'"
        #dt
        [tableStyle]="{ width: 'max-content' }"
        [value]="dataList"
        [autoLayout]="true"
        responsiveLayout="scroll"
        [paginator]="false"
        [rows]="rows"
        showLoader="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} discounts"
        [globalFilterFields]="['customerName']"
        [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
        selectionMode="single"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Codes</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th style="text-align: center">Customer Type</th>
                <th>Allowed Locations</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" class="text-center">
                <td>{{ item.discountName }}</td>
                <td>{{ item.couponCodesListWithSpace }}</td>
                <td>
                    <span *ngIf="item.validity == 1">{{
                        item.validityStartDate | date : "MM/dd/yyyy"
                    }}</span>
                </td>
                <td>
                    <span *ngIf="item.validity == 1">{{
                        item.validityEndDate | date : "MM/dd/yyyy"
                    }}</span>
                </td>
                <td style="text-align: center">
                    <span *ngIf="item.customerType == 0">ALL</span>
                    <span *ngIf="item.customerType == 1">Loyalty</span>
                    <span *ngIf="item.customerType == 2">Walk-in Customer</span>
                    <span *ngIf="item.customerType == 3">Group</span>
                </td>
                <td>{{ item.allowedLocationsListString }}</td>
                <td style="text-align: center;padding:20%" class="{{
                    item.isActive == true
                        ? 'Active badge'
                        : 'In-Active badge'
                }}">
                    <span>{{
                        item.isActive == true ? "Active" : "Inactive"
                        }}</span>
                </td>
                <td>
                    <button
                        pButton
                        pRipple
                        icon="pi pi-angle-down"
                        iconPos="right"
                        type="button"
                        label="Actions"
                        class="n-action-button"
                        (click)="op.toggle($event)"
                        (click)="actionButtonClick(item)"
                    ></button>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <!-- Card View -->
    <div *ngIf="dataList?.length > 0 && viewMode === 'card'" class="grid">
        <div *ngFor="let item of dataList">
            <div class="discount-card" [class.selected]="selectedCardId === item.id" (click)="selectedCardId = selectedCardId === item.id ? null : item.id">
                <!-- Card Header with Discount Name -->
                <div class="card-header flex align-items-center gap-2">
                    <span class="conn-flex-image-first-letter">{{ item.discountName | slice : 0 : 1 }}</span>
                    <div class="flex-grow-1">
                        <div class="font-semibold">{{ item.discountName }}</div>
                        <div class="card-contact">
                            <span *ngIf="item.validity == 1">
                                {{ item.validityStartDate | date : "MM/dd/yyyy" }} - {{ item.validityEndDate | date : "MM/dd/yyyy" }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Card Body - Details (Always Visible) -->
                <div class="card-body pt-2">
                    <div class="card-detail mb-2">
                        <div class="detail-label">Type:</div>
                        <div class="detail-value">
                            <span *ngIf="item.customerType == 0">ALL</span>
                            <span *ngIf="item.customerType == 1">Loyalty</span>
                            <span *ngIf="item.customerType == 2">Walk-in Customer</span>
                            <span *ngIf="item.customerType == 3">Group</span>
                        </div>
                    </div>
                    
                    <div class="card-detail mb-2">
                        <div class="detail-label">Codes:</div>
                        <div class="detail-value text-break">{{ item.couponCodesListWithSpace }}</div>
                    </div>
                    
                    <div class="card-detail mb-2">
                        <div class="detail-label">Start Date:</div>
                        <div class="detail-value">
                            <span *ngIf="item.validity == 1">{{ item.validityStartDate | date : "MM/dd/yyyy" }}</span>
                            <span *ngIf="item.validity != 1">N/A</span>
                        </div>
                    </div>

                    <div class="card-detail mb-2">
                        <div class="detail-label">End Date:</div>
                        <div class="detail-value">
                            <span *ngIf="item.validity == 1">{{ item.validityEndDate | date : "MM/dd/yyyy" }}</span>
                            <span *ngIf="item.validity != 1">N/A</span>
                        </div>
                    </div>

                    <div class="card-detail mb-2">
                        <div class="detail-label">Locations:</div>
                        <div class="detail-value text-break">{{ item.allowedLocationsListString }}</div>
                    </div>

                    <div class="card-detail mb-2">
                        <div class="detail-label">Status:</div>
                        <div class="detail-value" [class.badge-active]="item.isActive" [class.badge-inactive]="!item.isActive">
                            {{ item.isActive ? "Active" : "Inactive" }}
                        </div>
                    </div>
                </div>

                <!-- Card Footer - Actions (Show only when selected) -->
                <div class="card-footer flex gap-2 pt-2 border-top-1 surface-border" *ngIf="selectedCardId === item.id">
                    <button pButton pRipple type="button" icon="pi pi-pencil" 
                        class="p-button-rounded p-button-text flex-grow-1" 
                        title="Edit"
                        (click)="actionButtonClick(item); editButtonClicked(); $event.stopPropagation()"></button>
                    <button pButton pRipple type="button" icon="pi pi-refresh" 
                        class="p-button-rounded p-button-text flex-grow-1" 
                        title="Change Status"
                        (click)="actionButtonClick(item); optionStatusChangeClicked(); $event.stopPropagation()"></button>
                    <button pButton pRipple type="button" icon="pi pi-trash" 
                        class="p-button-rounded p-button-text p-button-danger flex-grow-1" 
                        title="Delete"
                        (click)="actionButtonClick(item); optionDeleteClicked(); $event.stopPropagation()"></button>
                </div>
            </div>
        </div>
    </div>

    <!-- No Data Message -->
    <div class="flex" *ngIf="dataList?.length == 0">
        <div class="text-align-center" style="width: 100%">
            <span class="control-description text-muted text-align-center">
                No discount found!</span
            >
        </div>
    </div>

    <!-- Paginator -->
    <div>
        <p-paginator
            #p
            [first]="first"
            *ngIf="dataList?.length"
            (onPageChange)="onPageChange($event)"
            [rows]="rows"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 25, 50, 100, 500, 1000]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Records: {first} of {last}, Total Records: {totalRecords}"
        >
        </p-paginator>
    </div>
</div>

<p-dialog
    *ngIf="_discountsService.showEditDiscount"
    header="Edit Discount Details"
    [(visible)]="_discountsService.showEditDiscount"
    [style]="{ width: '80%' }"
    modal="true"
>
    <app-new-edit-discounts
        [singupBusinessConfig]="true"
        [isNew]="false"
        [isViewOnly]="isViewOnly"
        (onSubmit)="refrestDataList($event)"
    ></app-new-edit-discounts>
</p-dialog>


    <p-dialog *ngIf="_discountsService.showNewEditDiscount"
        header="Add New Discount"
        [(visible)]="_discountsService.showNewEditDiscount"
        [style]="{ maxWidth: '100vw' }"
        modal="true"
    >
        <app-new-edit-discounts
            [singupBusinessConfig]="true"
            [isNew]="true"
            [isViewOnly]="false"
            (onSubmit)="refrestDataList($event)"
        ></app-new-edit-discounts>
    </p-dialog>

